import type { SVGProps } from 'react';

export function IconChevronLeft(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...props}
        >
            <polyline points="15 18 9 12 15 6" />
        </svg>
    );
}
